import React, { useState } from 'react';
import Apis from '../Apis';
import { showAlert } from '../ui/dialog';
import { useNavigate } from 'react-router-dom';
const Spinner = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" style={{ animation: 'ge-spin 0.8s linear infinite' }}>
    <circle cx="9" cy="9" r="7" fill="none" stroke="#9ca3af" strokeWidth="2" strokeDasharray="22 22" strokeLinecap="round" />
    <style>{`@keyframes ge-spin{to{transform:rotate(360deg);}}`}</style>
  </svg>
);

const DARK = '#1e3a4c';
const DARK_HOVER = '#162e3c';

const inputBase = {
  width: '100%', height: 42, padding: '0 12px',
  border: '1px solid #d1d5db', borderRadius: 4,
  fontSize: 14, fontFamily: 'inherit', color: '#111827',
  background: '#fff', outline: 'none', boxSizing: 'border-box',
  transition: 'border-color 0.15s',
};

const features = [
  'Pedidos em tempo real',
  'Controle de clientes e representantes',
  'Gestão de produtos e estoque',
  'Relatórios e visitas comerciais',
];

export default function Login({ setToken }) {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);

  const alertErr = (msg) =>
    showAlert({ title: 'Atenção', text: msg, icon: 'error', dangerMode: true });

  const handleLogin = () => {
    if (!usuario || !senha) { alertErr('Preencha todos os campos'); return; }
    setLoading(true);
    fetch(Apis.urlLogin, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: usuario, senha }),
    })
      .then(r => r.json())
      .then(res => {
        if (res.retorno.sucesso) {
          localStorage.setItem('token', res.retorno.token);
          localStorage.setItem('email', res.retorno.email);
          localStorage.setItem('nome', res.retorno.nome);
          localStorage.setItem('id', res.retorno.id);
          localStorage.setItem('imagemLogin', res.retorno.imagem_login);
          setToken(res.retorno.token);
          navigate('/home');
        } else {
          alertErr(res.retorno.mensagem);
        }
      })
      .catch(() => alertErr('Erro ao conectar. Tente novamente.'))
      .finally(() => setLoading(false));
  };

  const onKey = (e) => { if (e.key === 'Enter') handleLogin(); };
  console.log("Teste de commit");

  return (
    <div style={{ minHeight: '100vh', display: 'flex', maxWidth: 1920, margin: '0 auto' }}>

      {/* ── Left panel ── */}
      <div style={{
        flex: 1, background: DARK,
        flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        padding: '48px 56px', position: 'relative', overflow: 'hidden',
        display: window.innerWidth < 900 ? 'none' : 'flex',
      }}>
        <p style={{ position: 'absolute', bottom: 32, color: '#3d6a85', fontSize: 12, margin: 0 }}>
          © {new Date().getFullYear()} GE Sistemas
        </p>
        <div style={{
          position: 'absolute', inset: 0, opacity: 0.04,
          backgroundImage: 'linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)',
          backgroundSize: '40px 40px',
        }} />

        <div style={{ position: 'relative', textAlign: 'center' }}>
          <h2 style={{ color: '#fff', fontSize: 32, fontWeight: 700, lineHeight: 1.25, margin: '0 0 16px', letterSpacing: '-0.5px' }}>
            Gerencie seus pedidos<br />
            <span style={{ color: '#94b8cc' }}>com eficiência.</span>
          </h2>
          <p style={{ color: '#6b8fa3', fontSize: 14, lineHeight: 1.75, margin: '0 0 40px' }}>
            Plataforma completa para equipes comerciais.
          </p>

          {features.map(f => (
            <div key={f} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 14 }}>
              <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#3d6a85', flexShrink: 0 }} />
              <span style={{ color: '#8ab0c4', fontSize: 13.5 }}>{f}</span>
            </div>
          ))}
        </div>

      </div>

      {/* ── Right form ── */}
      <div style={{
        flex: 1, background: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '48px 40px', boxSizing: 'border-box',
        borderLeft: '1px solid #e5e7eb',
      }}>
        <div style={{ width: '100%', maxWidth: 400 }}>

          <div style={{ marginBottom: 36 }}>
            <h1 style={{ margin: '0 0 6px', fontSize: 22, fontWeight: 700, color: '#111827', letterSpacing: '-0.3px' }}>
              Entrar na plataforma
            </h1>
            <p style={{ margin: 0, fontSize: 13.5, color: '#6b7280' }}>
              Use suas credenciais para acessar o painel
            </p>
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>Usuário</label>
            <input
              type="text" placeholder="Seu e-mail ou usuário"
              value={usuario} onChange={e => setUsuario(e.target.value)} onKeyDown={onKey}
              style={inputBase}
              onFocus={e => e.target.style.borderColor = DARK}
              onBlur={e => e.target.style.borderColor = '#d1d5db'}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <label style={{ fontSize: 13, fontWeight: 500, color: '#374151' }}>Senha</label>
              <button onClick={() => navigate('/alterar-senha')} style={{
                background: 'none', border: 'none', cursor: 'pointer', padding: 0,
                color: '#6b7280', fontSize: 12, fontFamily: 'inherit',
                textDecoration: 'underline', textUnderlineOffset: 3,
              }}>
                Esqueceu a senha?
              </button>
            </div>
            <div style={{ position: 'relative' }}>
              <input
                type={showPwd ? 'text' : 'password'} placeholder="Sua senha"
                value={senha} onChange={e => setSenha(e.target.value)} onKeyDown={onKey}
                style={{ ...inputBase, paddingRight: 40 }}
                onFocus={e => e.target.style.borderColor = DARK}
                onBlur={e => e.target.style.borderColor = '#d1d5db'}
              />
              <button type="button" onClick={() => setShowPwd(p => !p)} style={{
                position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
                background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', padding: 4, display: 'flex',
              }}>
                {showPwd
                  ? <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></svg>
                  : <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                }
              </button>
            </div>
          </div>

          <button onClick={handleLogin} disabled={loading} style={{
            width: '100%', height: 42, borderRadius: 4, border: 'none',
            background: loading ? '#e5e7eb' : DARK,
            color: loading ? '#9ca3af' : '#fff',
            fontSize: 14, fontWeight: 600, cursor: loading ? 'default' : 'pointer',
            fontFamily: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: 'background 0.15s',
          }}
            onMouseEnter={e => { if (!loading) e.currentTarget.style.background = DARK_HOVER; }}
            onMouseLeave={e => { if (!loading) e.currentTarget.style.background = DARK; }}
          >
            {loading ? <Spinner /> : 'Entrar'}
          </button>

          <div style={{ marginTop: 14 }}>
            <span style={{ fontSize: 13, color: '#9ca3af' }}>Não tem conta? </span>
            <button onClick={() => navigate('/cadastrar-empresa')} style={{
              background: 'none', border: 'none', cursor: 'pointer', padding: 0,
              color: DARK, fontSize: 13, fontFamily: 'inherit', fontWeight: 500,
              textDecoration: 'underline', textUnderlineOffset: 3,
            }}>
              Criar conta
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
